import { ThirdPartiesLib } from './third-parties';
import { ProofsLib } from '@pok/proofs';
class WebLib {
    thirdParties(config) {
        return new ThirdPartiesLib(config.chainId, config.certificatesContractAddress);
    }
    proofs(proofs, proofsProxyBaseUri) {
        return new ProofsLib(proofs, proofsProxyBaseUri);
    }
}
export const webLib = new WebLib();
//# sourceMappingURL=lib.js.map